import { render, staticRenderFns } from "./PrepaidsTable.vue?vue&type=template&id=83b69392"
import script from "./PrepaidsTable.vue?vue&type=script&lang=js"
export * from "./PrepaidsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports